<p-toast key="detailEntretien"></p-toast>

<p-blockUI [blocked]="blocked">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-blockUI>


<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div #contenu *ngIf="EstCharge()">

    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 my-2">
			<label for="note">Description</label>
			<input #champDescription id="note" type="text" pInputText [(ngModel)]="item.description" (keyup.enter)="enregistrer()" > 
        </div>
        <div class="flex flex-column gap-2 col-12 md:col-8 p-md-3 my-2">
            <label for="lastname">Code de catégorie</label>
            <p-dropdown [options]="listeCategories" [(ngModel)]="item.categorie"
                optionLabel="description" [showClear]="true" filter="true" filterBy="code,description" appendTo="body"
                placeholder="Sélectionner une catégorie...">
                <ng-template pTemplate="selectedItem">
                    <div *ngIf="item.categorie">
                        <div>{{item.categorie.code}} - {{item.categorie.description}}
                        </div>
                    </div>
                </ng-template>
                <ng-template let-categorie pTemplate="item">
                    <div>
                        <div>{{categorie.code}} - {{categorie.description}}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="flex flex-column gap-2 col-12 md:col-4 my-2">
            <label for="ordre">Ordre</label>
            <p-inputNumber [(ngModel)]="item.ordre" [min]="1" [max]="maxOrdre" [step]="1" [showButtons]="true" buttonLayout="horizontal" ></p-inputNumber>
        </div>
       <!--  <div class="flex flex-column gap-2 col-12 md:col-6">
            <label for="note">Note</label>
            <input id="note" type="text" pInputText [(ngModel)]="pieceUnite.note">
        </div> -->
    </div>

  
</div>


<div class="text-right mt-3">

    <button pButton pRipple label="Enregistrer" icon="pi pi-save" class="p-button-primary"
        (click)="enregistrer()"></button>
    <button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text" (click)="annuler()"></button>

</div>